import { WebPlugin } from '@capacitor/core';
export class InAppReviewWeb extends WebPlugin {
    async requestReview() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map